import { COLORS } from '~/data/ui/colors';

export const useStyles = () => ({
  ToastDivStyle: {
    direction: 'rtl',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
});

export const ToastStyle = {
  direction: 'rtl',
  backgroundColor: COLORS.primary.light,
};
